import { LogoLoader } from '@gokrew/ui';
import { TranslationNS } from '@/constants/translation-namespaces';
import { useTranslation } from 'react-i18next';

export function AppLoaderPage({ error }: { error?: boolean | '' }) {
  const { t } = useTranslation(TranslationNS.Profile);
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex items-center justify-center min-h-dvh p-6 bg-white sm:bg-gray-200"
    >
      <div className="flex flex-col gap-10 bg-white items-center justify-center px-6 py-8 w-full max-w-xl rounded-2xl">
        <LogoLoader size="lg" />

        <p id="tagline" className="text-center text-sm text-gray-500">
          {error === '' || error
            ? t('toast_message.something_went_wrong')
            : t('toast_message.preparing_experience')}
        </p>
      </div>
    </div>
  );
}
